<template>
  <div>
    <div id="layoutAuthentication">
      <div id="layoutAuthentication_content">
        <main>
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-5">
                <div class="card shadow-lg border-0 rounded-lg mt-5">
                  <div class="card-header"><h3 class="text-center font-weight-light my-4">Login</h3></div>
                  <div class="card-body">
                    <form>
                    <slot />
                    </form>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthContainer'
}
</script>

<style scoped>

</style>
